export type Prayer={name:string;level:number;drain:number;icon:string;group:string;accuracy?:number;strength?:number;defence?:number;overhead?:'magic'|'range'|'melee';supported?:boolean};
// Default unfiltered prayer order. Deadeye/Mystic Vigour replace their upgraded icons when unlocked.
export const PRAYERS:Prayer[]=[
 {name:'Thick Skin',level:1,drain:1,icon:'skin',group:'defence',defence:1.05},
 {name:'Burst of Strength',level:4,drain:1,icon:'strength',group:'strength'},
 {name:'Clarity of Thought',level:7,drain:1,icon:'attack',group:'attack'},
 {name:'Sharp Eye',level:8,drain:1,icon:'range',group:'offensive',accuracy:1.05,strength:1.05},
 {name:'Mystic Will',level:9,drain:1,icon:'magic',group:'offensive',supported:false},
 {name:'Rock Skin',level:10,drain:2,icon:'skin',group:'defence',defence:1.10},
 {name:'Superhuman Strength',level:13,drain:2,icon:'strength',group:'strength'},
 {name:'Improved Reflexes',level:16,drain:2,icon:'attack',group:'attack'},
 {name:'Rapid Restore',level:19,drain:1,icon:'restore',group:'aux'},
 {name:'Rapid Heal',level:22,drain:2,icon:'heal',group:'aux'},
 {name:'Protect Item',level:25,drain:2,icon:'item',group:'aux',supported:false},
 {name:'Hawk Eye',level:26,drain:6,icon:'range',group:'offensive',accuracy:1.1,strength:1.1},
 {name:'Mystic Lore',level:27,drain:6,icon:'magic',group:'offensive',supported:false},
 {name:'Steel Skin',level:28,drain:6,icon:'skin',group:'defence',defence:1.15},
 {name:'Ultimate Strength',level:31,drain:6,icon:'strength',group:'strength'},
 {name:'Incredible Reflexes',level:34,drain:6,icon:'attack',group:'attack'},
 {name:'Protect from Magic',level:37,drain:12,icon:'magic',group:'overhead',overhead:'magic'},
 {name:'Protect from Missiles',level:40,drain:12,icon:'range',group:'overhead',overhead:'range'},
 {name:'Protect from Melee',level:43,drain:12,icon:'melee',group:'overhead',overhead:'melee'},
 {name:'Deadeye',level:62,drain:12,icon:'range',group:'offensive',accuracy:1.18,strength:1.18,defence:1.05},
 {name:'Mystic Vigour',level:63,drain:12,icon:'magic',group:'offensive',supported:false},
 {name:'Retribution',level:46,drain:3,icon:'retribution',group:'overhead',supported:false},
 {name:'Redemption',level:49,drain:6,icon:'heal',group:'overhead',supported:false},
 {name:'Smite',level:52,drain:18,icon:'smite',group:'overhead',supported:false},
 {name:'Preserve',level:55,drain:2,icon:'preserve',group:'aux'},
 {name:'Chivalry',level:60,drain:24,icon:'melee',group:'offensive',defence:1.2},
 {name:'Piety',level:70,drain:24,icon:'melee',group:'offensive',defence:1.25},
 {name:'Rigour',level:74,drain:24,icon:'rigour',group:'offensive',accuracy:1.2,strength:1.23,defence:1.25},
 {name:'Augury',level:77,drain:24,icon:'magic',group:'offensive',defence:1.25}
];
export const prayerByName=(name:string|null)=>PRAYERS.find(p=>p.name===name);
